import { createContext } from 'react';

import { RegisterWidgetSitePanelSave } from '@/components/widgetConfigSiteTabbedShell/widgetConfigSiteTabbedShell/widgetConfigSiteTabbedShell.types.ts';
import { useRequiredContext } from '@/hooks';
import { InventorySiteSection, WidgetConfigModalProps } from '@/types.ts';

export type WidgetSitePanelContextValue = {
  section: InventorySiteSection;
  onSave: WidgetConfigModalProps['onSave'];
  registerSave: RegisterWidgetSitePanelSave;
};

export const WidgetSitePanelContext = createContext<WidgetSitePanelContextValue | undefined>(
  undefined
);

export const useWidgetSitePanelCtx = () =>
  useRequiredContext({
    context: WidgetSitePanelContext,
    hookName: 'useWidgetSitePanel',
    providerName: 'WidgetSitePanelProvider',
  });
